import { Component, input, viewChild, ElementRef } from '@angular/core';
import { NovaIcon } from '@rds-nova/angular-icon';
import { TranslatePipe } from 'node_modules/@ngx-translate/core';
import { NovaButton } from 'node_modules/@rds-nova/angular-button';
import { TrackedButtonDirective } from 'src/app/core/analytics/directives/tracked-button.directive';

@Component({
  selector: 'app-simple-dialog',
  template: `
    <dialog #dialogElement>
      <div class="dialog-header">
        <h2 class="nova-heading-24">{{ title() }}</h2>
        <button
          novaButton
          appTrackedButton
          [trackId]="analyticsPrefix() + ':dialog-close'"
          [trackType]="'close'"
          [isIcon]="true"
          [variant]="'subtle'"
          [size]="'small'"
          (click)="close()"
          [attr.aria-label]="'dialog.closeButtonAltText' | translate"
        >
          <nova-icon name="close" />
        </button>
      </div>
      <ng-content />
    </dialog>
  `,
  styles: [
    `
      dialog {
        background: var(--nova-bg-primary);
        padding: 24px;
        border-radius: 24px;
        box-shadow: var(--nova-elevation-5);
        border: 1px solid var(--nova-border);
      }

      dialog::backdrop {
        background: var(--nova-gray-50-opacity);
      }

      .dialog-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
      }
    `,
  ],
  imports: [NovaButton, NovaIcon, TranslatePipe, TrackedButtonDirective],
})
export class SimpleDialogComponent {
  analyticsPrefix = input.required<string>();
  title = input.required<string>();

  dialogElement =
    viewChild.required<ElementRef<HTMLDialogElement>>('dialogElement');

  open() {
    this.dialogElement().nativeElement.showModal();
  }

  close() {
    this.dialogElement().nativeElement.close();
  }
}
